import React from 'react';
import styles from '../Field.module.scss';
import { InfoFieldProps } from '../../../../../types/props';

export const InfoField: React.FC<InfoFieldProps> = ({name, content, style}) => {
    return (
        <div className={styles.infoField} style={style}>
            <span className={styles.name}>{name}</span>
            <span className={styles.content}>{content}</span>
        </div>
    )
}